export default __webpack_public_path__ + "static/media/dickheads.006fadbc.png";